module.exports = __webpack_public_path__ + "static/media/make_payment_button_grey.3cea3cc4.svg";